import React, { useEffect } from "react";
import HeroBg from "../../assets/images/hero-bg.png";
import HeroCar from "../../assets/images/herocar.png";
import "aos/dist/aos.css";
import AOS from "aos";

const HeroSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="w-full min-h-[55vh] flex lg:flex-row flex-col relative rounded-xl">
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-50/30 to-transparent z-0 pointer-events-none"></div>

      <div className="lg:w-1/2 flex justify-center items-center w-full z-10 relative py-16 lg:py-0">
        <div className="h-full flex flex-col justify-center items-center lg:items-start px-4 lg:px-8">
          <div
            className="text-4xl sm:text-5xl lg:text-7xl font-bold font-mazzardbold my-2 bg-clip-text text-transparent bg-gradient-to-r from-black to-blue-900"
            data-aos="fade-right"
          >
            Fusion Cab
          </div>
          <div
            className="my-3 text-2xl sm:text-2xl lg:text-3xl lg:text-left text-center w-full lg:w-4/5 font-mazzardextralight"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <span className="font-mazzardbold">Get Ready to Redefine</span>{" "}
            Chauffeur Driven Cab Rentals!
          </div>
          <div
            className="my-3 lg:text-left text-center text-lg text-gray-700"
            data-aos="fade-right"
            data-aos-delay="400"
          >
            We are{" "}
            <span className="text-blue-800 font-semibold">Launching Soon</span>{" "}
            a seamless, tech-enabled cab rental experience tailored to your
            needs
          </div>
          <button
            className="mt-6 px-8 py-3 bg-black text-white rounded-full hover:bg-blue-900 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            Get Notified
          </button>
        </div>
      </div>
      <div
        className="lg:w-1/2 h-full w-full flex justify-center items-center relative z-10"
        data-aos="fade-left"
        data-aos-delay="300"
      >
        <div className="content w-full relative h-full">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] lg:w-[500px] lg:h-[500px] rounded-full bg-blue-100/50 filter blur-3xl z-0"></div>
          <img alt="" className="w-full relative z-10" src={HeroBg} />
          <img
            alt=""
            src={HeroCar}
            style={{
              position: "absolute",
              zIndex: 20,
              right: "0%",
              bottom: "-100px",
            }}
            className="animate-slideInRight z-20 w-[90%] lg:w-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
